module.exports = __webpack_public_path__ + "img/7.f5f95b77.png";